// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pulse-button {
    position: relative;
    width: 15rem;
    height: 15rem;
    border: none;
    /* box-shadow: 0 0 0 0 rgb(0, 166, 217);
    background-color: rgb(0, 117, 186); */
    border-radius: 50%;
    /* background-image: url(YOUR-URL-IMAGE.png); */
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    font-size: 2.5rem;
    color: white;
    font-weight: bold;
    margin: auto auto auto auto;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pulse-button.pause {
    box-shadow: 0 0 0 0 rgb(0, 166, 217);
    background-color: rgb(0, 117, 186);
}
.pulse-button.play {
    box-shadow: 0 0 0 0 rgb(228, 1, 30);
    background-color: rgb(151, 10, 49);
}

/* .pulse-button:hover {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none;
} */
.pulse-button.play:active {
    /* -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none; */
    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    background-color: rgb(151, 10, 49);
}
.pulse-button.pause:active {
    /* -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none; */
    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    background-color: rgb(2, 48, 103);
}
@keyframes pulse {
    to {
        box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
    }
}
.mani-button {
    width: 3.5rem !important;
    height: 3.5rem !important;
    color: rgb(75, 61, 48);
     /* color: rgb(228, 158, 74) */
}
.mani-button-wide{
    width: 6rem !important;
    height: 6rem !important;
    color: rgb(75, 61, 48);
}
.play-button {
    color: rgb(121, 207, 159);
}
.pause-button {
    color: rgb(224, 94, 109);
}

.timer-wrapper {
    display: flex;
    justify-content: center;
}

.text {
    color: #aaa;
}

.value {
    font-size: 2rem;
}

.answer-image-auto {
    margin: auto;
    object-fit: scale-down;
    border-radius: 15%;
    max-height: 50vh !important;
    /* min-height: fit-content !important; */
    /* min-width: fit-content !important; */
    max-width: 90% !important;
    -moz-border-radius: 15%;
    -webkit-border-radius: 15%;
    overflow: hidden;
    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/PlayPageAuto.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ;yCACqC;IACrC,kBAAkB;IAClB,+CAA+C;IAC/C,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IAIf,2DAA2D;IAC3D,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;AACA;IACI,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;;;;;GAKG;AACH;IACI;;;sBAGkB;IAIlB,2DAA2D;IAC3D,kCAAkC;AACtC;AACA;IACI;;;sBAGkB;IAIlB,2DAA2D;IAC3D,iCAAiC;AACrC;AAgBA;IACI;QACI,2CAA2C;IAC/C;AACJ;AACA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;KACrB,6BAA6B;AAClC;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,wCAAwC;IACxC,uCAAuC;IACvC,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC","sourcesContent":[".pulse-button {\r\n    position: relative;\r\n    width: 15rem;\r\n    height: 15rem;\r\n    border: none;\r\n    /* box-shadow: 0 0 0 0 rgb(0, 166, 217);\r\n    background-color: rgb(0, 117, 186); */\r\n    border-radius: 50%;\r\n    /* background-image: url(YOUR-URL-IMAGE.png); */\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    cursor: pointer;\r\n    -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    font-size: 2.5rem;\r\n    color: white;\r\n    font-weight: bold;\r\n    margin: auto auto auto auto;\r\n    white-space: nowrap;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.pulse-button.pause {\r\n    box-shadow: 0 0 0 0 rgb(0, 166, 217);\r\n    background-color: rgb(0, 117, 186);\r\n}\r\n.pulse-button.play {\r\n    box-shadow: 0 0 0 0 rgb(228, 1, 30);\r\n    background-color: rgb(151, 10, 49);\r\n}\r\n\r\n/* .pulse-button:hover {\r\n    -webkit-animation: none;\r\n    -moz-animation: none;\r\n    -ms-animation: none;\r\n    animation: none;\r\n} */\r\n.pulse-button.play:active {\r\n    /* -webkit-animation: none;\r\n    -moz-animation: none;\r\n    -ms-animation: none;\r\n    animation: none; */\r\n    -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    background-color: rgb(151, 10, 49);\r\n}\r\n.pulse-button.pause:active {\r\n    /* -webkit-animation: none;\r\n    -moz-animation: none;\r\n    -ms-animation: none;\r\n    animation: none; */\r\n    -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n    background-color: rgb(2, 48, 103);\r\n}\r\n@-webkit-keyframes pulse {\r\n    to {\r\n        box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);\r\n    }\r\n}\r\n@-moz-keyframes pulse {\r\n    to {\r\n        box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);\r\n    }\r\n}\r\n@-ms-keyframes pulse {\r\n    to {\r\n        box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);\r\n    }\r\n}\r\n@keyframes pulse {\r\n    to {\r\n        box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);\r\n    }\r\n}\r\n.mani-button {\r\n    width: 3.5rem !important;\r\n    height: 3.5rem !important;\r\n    color: rgb(75, 61, 48);\r\n     /* color: rgb(228, 158, 74) */\r\n}\r\n.mani-button-wide{\r\n    width: 6rem !important;\r\n    height: 6rem !important;\r\n    color: rgb(75, 61, 48);\r\n}\r\n.play-button {\r\n    color: rgb(121, 207, 159);\r\n}\r\n.pause-button {\r\n    color: rgb(224, 94, 109);\r\n}\r\n\r\n.timer-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.text {\r\n    color: #aaa;\r\n}\r\n\r\n.value {\r\n    font-size: 2rem;\r\n}\r\n\r\n.answer-image-auto {\r\n    margin: auto;\r\n    object-fit: scale-down;\r\n    border-radius: 15%;\r\n    max-height: 50vh !important;\r\n    /* min-height: fit-content !important; */\r\n    /* min-width: fit-content !important; */\r\n    max-width: 90% !important;\r\n    -moz-border-radius: 15%;\r\n    -webkit-border-radius: 15%;\r\n    overflow: hidden;\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
